import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, loadOptions } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.get("/auth/session", { headers: { "X-Session-ID": sid } });
        setUser(data);
        await loadOptions();
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError(errMsg(e));
      }
    })();
  }, [navigate, setUser, loadOptions]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFDFD]" data-testid="auth-callback">
      <p className="text-sm text-[#6B7280]">
        {error ? `Sign-in failed: ${error}` : "Signing you in to LabTrack…"}
      </p>
    </div>
  );
}
